/* eslint-disable react/prop-types */
import React from "react";
import { FieldProps } from "formik";
import PinInput from "react-pin-input";

type Props = FieldProps<string> & { onComplete: () => void; innerRef?: (instance: any) => void };

export const FormikPin: React.ComponentType<Props> = ({
  field,
  form: { touched, errors, setFieldValue },
  onComplete,
  innerRef
}) => (
  <div>
    <PinInput
      length={4}
      initialValue={field.value}
      type="numeric"
      onChange={value => {
        setFieldValue(field.name, value);
      }}
      onComplete={() => {
        onComplete();
      }}
      ref={innerRef}
    />
    {touched[field.name] && errors[field.name] && (
      <div className="formik-error">{errors[field.name]}</div>
    )}
  </div>
);

export default FormikPin;
